import { ColDef, ColGroupDef } from "ag-grid-community/dist/lib/entities/colDef";
import { Badge } from "react-bootstrap";

export function getCatalogueStoresConfig(stores: any, catalogue: any): (ColDef<any> | ColGroupDef<any>)[] | null {
    return [
        {
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",
            field: "name",
            sort: "asc", 
            sortable: true,
            flex: 1,
            minWidth: 400
        },
        {
            headerName: "Store Status",
            flex: 1,
             cellRendererSelector: (params) => {
                  return {
                      component: 'baseCellRenderer',
                      params: {
                                  children: stores.table.find((i: any) => i.id == params.data.id)?.connected === true? (<Badge className="me-1 badge-outline-success">Online</Badge>) : (<Badge className="me-1 badge-outline-danger">Offline</Badge>),
                              }                   
                  }
              }
        },
        {
          headerName: "Status",
          flex: 1,
          cellRendererSelector: (params) => {
            return {
                component: 'baseCellRenderer',
                params: {
                            children: catalogue.sentStoreList.includes(params.data.id as never) ? (<Badge className="me-1 badge-outline-success">Sent</Badge>) : (<Badge className="me-1 badge-outline-warning">Pending</Badge>),
                        }                   
              }
          }
       },
        {
            headerName: "No. of lines",
            flex: 1,
            valueGetter: (params) => {
              const numberOfStock = catalogue.stores.find((i:any) => i.id == params.data.id);
              if(numberOfStock == null || numberOfStock?.lines == false)
                return;
              return numberOfStock.lines;
            }
         }
    ]
}